module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ru-RU.70196d1c.jpg";